import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { IconEdit } from '../../components/icons/Icons';
import { ThreadOptionsStructure } from './ThreadOptionStructure';

const messages = defineMessages({
  edit: { defaultMessage: 'Editer le commentaire', id: 'tb/s75' },
});

export const EditOption: React.FC<{ startEditing?: () => void }> = ({ startEditing }) => {
  return (
    <ThreadOptionsStructure
      icon={<IconEdit />}
      title={<FormattedMessage {...messages.edit} />}
      onClick={startEditing}
    />
  );
};
